import { gql } from 'graphql-request';

export interface NewsCategory {
  id: string;
  name: string;
}

export const createNewsCategoriesQuery = () => gql`
  query getNewsCategories {
    NewsCategories {
      docs {
        id
        name
      }
    }
  }
`;

export const mapToNewsCategories = (data: any): NewsCategory[] => {
  return data?.NewsCategories?.docs.map((item: any) => ({
    id: item.id,
    name: item.name,
  }));
};
